@if (mode() === 'icon') {
  <Tooltip [label]="label()" [placement]="tooltipPlacement()"
    ><Text color="on-primary-surface-variant">
      <button
        text-button
        [size]="size()"
        symbolLeft="download"
        variant="ghost"
        (click)="download()"
        [loading]="downloading()"
        [disable]="disable()"
      >
        Download
      </button>
    </Text>
  </Tooltip>
} @else {
  <button
    text-button
    [size]="size()"
    (click)="download()"
    [loading]="downloading()"
    [disable]="disable()"
    symbolLeft="download"
  >
    {{ label() }}
  </button>
}
